/**
 * SureKeep es SINGLE-TENANT en el backoffice: no hay picker de tenant ni llamada a
 * `resolve-tenants`. El `tenantId` se manda DIRECTO en cada request de auth
 * (login / challenge / forgot-password), igual que hace `fiado-agents-webapp` con su tenant.
 *
 * Configurable por env por si el id/nombre real en dev/staging/prod difiere del default.
 * El id debe coincidir con el registrado en `PlatformTenantConfig_GT` del pool de RBAC.
 */
export const SUREKEEP_TENANT_ID = import.meta.env.VITE_TENANT_ID?.trim() || 'surekeep';
export const SUREKEEP_TENANT_NAME = import.meta.env.VITE_TENANT_NAME?.trim() || 'SureKeep';
